import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APIService, ModuleType, QuestionType } from '../../API.service';
import { AdminService } from '../../services/admin.service';
import { saveAs } from 'file-saver' 
import { ViewModule } from '../../app.types';

@Component({
  selector: 'app-module-responses',
  templateUrl: './module-responses.component.html',
  styleUrls: ['./module-responses.component.scss']
})
export class ModuleResponsesComponent implements OnInit {

  constructor(private api: APIService, private admin: AdminService, private activatedRoute: ActivatedRoute) { }

  ModuleType = ModuleType;
  QuestionType = QuestionType;

  moduleObj: ViewModule;

  loading: boolean;

  choices: any = {};

  ngOnInit(): void {

    this.loading = true;

    this.activatedRoute.params.subscribe(async (params) => {

      var data = await this.api.getModuleForAdmin(params["moduleId"])

      this.moduleObj = new ViewModule()

      var allUsers = await this.admin.getAllUsers();

      await this.moduleObj.init(allUsers, data);

      this.moduleObj.questions.forEach(q => {
        if (q.type == QuestionType.LIKERT) {
          q["cols"] = ["ScaleLabel", "MinLabel", ...q.scaleOptionArray.map(o => "col" + o), "MaxLabel"]
        }
      })

      this.loading = false;

    })

  }

  sortUsers(event) {
    switch(event.active) {
      case ("Mark"):
        this.moduleObj.sortUsersByMark(event.direction)
        break;
      case ("Name"):
        this.moduleObj.sortUsersByName(event.direction)
        break
    }
  }


  downloadResponses() {

    var s = `Module: ${this.moduleObj.label}\n\n`

    var i = 1;

    this.moduleObj.questions.forEach(question => {

      s += `Question ${i}: ${question.value}\n\n`

      if (question.type == QuestionType.MULTIPLE_CHOICE) {

        question.userResponses.forEach((ur) => {

          ur.response.choices.forEach(choice => {
            s += `${ur.name}, ${question.choices.get(choice.id).value}\n`
          })

        })

      } else if (question.type == QuestionType.MULTIPLE_SELECT) {

        s += ','

        var choiceIds = []

        question.choices.forEach((choice, choiceId) => {
          s += `${choice.value},`
          choiceIds.push(choiceId);
        })

        s += '\n'

        question.userResponses.forEach((response) => {

          s += `${response.name},`

          choiceIds.forEach(choiceId => {

            if (response.response.choices.map(c => c.id).includes(choiceId)){
              s += '1'
            } else {
              s += '0'
            }
            s += ','

          })

          s += '\n'

        })
        

      } else if (question.type == QuestionType.LONG_FORM || question.type == QuestionType.SHORT_FORM) {

        question.userResponses.forEach((response) => {
          s += `${response.name},${response.response.value.split(/\r?\n/).filter(v => v != "").join("___")}\n`
        });

      } else if (question.type == QuestionType.LIKERT) {

        s+= ','

        for(var scaleOptionIndex = 0; scaleOptionIndex < question.scaleLength; scaleOptionIndex ++){

          s+= `,${scaleOptionIndex + 1}`

        }
        
        s += '\n'

        question.choicesOrdered.forEach((choice) => {

          var scaleLabel = choice.value[0] || "";
          var minLabel = choice.value[1] || question.defaultMinLabel || "";
          var maxLabel = choice.value[2] || question.defaultMaxLabel || "";

          s+= `${scaleLabel},${minLabel}`

          question.scaleOptionArray.forEach((scaleOptionIndex) => {
            s += `,${choice.responses[scaleOptionIndex]}`
          })

          s+= `,${maxLabel}\n`

        })


      }

      s += '\n'

      i++;

    })

    var blob = new Blob([s], {type: 'text/csv'})

    saveAs(blob, 'module_responses.csv');

  }

  downloadMarks() {
    
  }

  markResponse(response, questionID, userID, correct) {

    response.marking = true;

    this.api.UpdateResponse({
      id: response.id,
      moduleID: this.moduleObj.id,
      questionID: questionID,
      userID: userID,
      correctness: correct ? 100 : 0 
    }).then(r => {
      
      response.correct = r.correctness == 100;
      
      var user = this.moduleObj.users.get(userID)
      user.mark += response.correct ? 1 : -1; 

      response.marking = false;

    })

  }

}